import clsx from 'clsx';
import { useIsTruncated } from 'hooks/useIsTruncated';
import { useLayoutEffect } from 'react';
import HubertTooltip from '../HubertTooltip';

interface Props {
  label: string;
  className?: string;
}

const TruncatedLabel = ({ label, className }: Props) => {
  const { ref, isTruncated, checkTruncation } = useIsTruncated<HTMLSpanElement>();

  useLayoutEffect(() => {
    checkTruncation();
  }, [label, checkTruncation]);

  const content = (
    <span ref={ref} className={clsx('truncate', className)}>
      {label}
    </span>
  );

  if (!isTruncated) {
    return content;
  }

  return (
    <HubertTooltip delayDuration={0}>
      <HubertTooltip.Trigger asChild>{content}</HubertTooltip.Trigger>
      <HubertTooltip.Content
        side="top"
        showArrow={false}
        className="!max-w-[240px] !border !border-gray-200 !bg-white !text-gray-700 !shadow-md"
      >
        {label}
      </HubertTooltip.Content>
    </HubertTooltip>
  );
};

export default TruncatedLabel;
